import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, patchRequest, postRequest } from '../config/axios-config';

const getUserProfile = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getUserProfile
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateUserName = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateUserName,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateBrandName = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateBrandName,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateAovFactor = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateAovFactor,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateRatnaModalStatus = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateRatnaModalStatus,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateUserModalStatus = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateUserModalStatus,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const changePassword = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.changePassword,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const removeUserProfileImage = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.removeUserProfileImage
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateOnboardingStatus = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateOnboardingStatus
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateUserAddress = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateUserAddress,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const refuseGift = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.refuseGift
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateStrategySessionStatus = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateStrategySessionStatus
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const bookStrategySession = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.bookStrategySession
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const bulkEditInfluencers = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.bulkEditInfluencers,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateGoogleAnalyticsEventStatus = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateGoogleAnalyticsEventStatus,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateTeamMemberData = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateTeamMemberData,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export {
  getUserProfile,
  changePassword,
  removeUserProfileImage,
  updateOnboardingStatus,
  updateUserAddress,
  refuseGift,
  updateUserName,
  updateAovFactor,
  updateRatnaModalStatus,
  updateStrategySessionStatus,
  updateBrandName,
  bookStrategySession,
  bulkEditInfluencers,
  updateGoogleAnalyticsEventStatus,
  updateUserModalStatus,
  updateTeamMemberData,
};
